export default __webpack_public_path__ + "static/media/hdpe-blue.1c094b6e.jpg";